import {
  generateCURPRules,
  generateEmailRules,
  generateINERules,
  generatePhoneRules,
  generateRFCRules,
} from 'utils/rules';

const fieldsInfo = {};

const tabs = [
  {
    title: 'Información General',
    fields: [
      'nombre',
      'apellido_paterno',
      'apellido_materno',
      'genero',
      'estado_civil',
      'lada',
      'email',
      'email_alternativo',
    ],
  },
  {
    title: 'Información del Ciudadano',
    fields: [
      'RFC',
      'CURP',
      'INE',
      'fecha_nacimiento',
      'es_ciudadano_considerado',
      'tipo_de_considerado',
      'foto',
    ],
  },
];

const configs = {
  // info general
  nombre: {
    formItemProps: {
      label: 'Nombre',
    },
  },
  apellido_paterno: {
    formItemProps: {
      label: 'Apellido Paterno',
    },
  },
  apellido_materno: {
    formItemProps: {
      label: 'Apellido Materno',
    },
  },
  genero: {
    formItemProps: {
      label: 'Género',
    },
  },
  estado_civil: {
    formItemProps: {
      label: 'Estado Civil',
    },
  },
  lada: {
    controlProps: {
      names: {
        lada: 'lada',
        numero_de_telefono: 'numero_de_celular',
      },
      rules: {
        numero_de_celular: generatePhoneRules({ tipoDePadron: 1, validateUnique: true }),
      },
      fullSize: true,
    },
  },
  email: {
    formItemProps: {
      label: 'Correo electrónico',
      rules: generateEmailRules({ required: true, tipoDePadron: 1, validateUnique: true }),
    },
  },
  email_alternativo: {
    formItemProps: {
      label: 'Correo electrónico alternativo',
    },
  },
  // info ciudadano
  foto: {
    avatar: true,
  },
  RFC: {
    formItemProps: {
      label: 'RFC',
      rules: generateRFCRules({ validateUnique: true, tipoDePadron: 1, tipoDePersona: 1 }),
    },
  },
  CURP: {
    formItemProps: {
      label: 'CURP',
      rules: generateCURPRules({ validateUnique: true, tipoDePadron: 1 }),
    },
  },
  INE: {
    formItemProps: {
      label: 'INE',
      rules: generateINERules({ validateUnique: true, tipoDePadron: 1 }),
    },
  },
  fecha_nacimiento: {
    formItemProps: {
      label: 'Fecha de nacimiento',
    },
  },
  es_ciudadano_considerado: {
    formItemProps: {
      label: '¿Es Ciudadano Considerado?',
    },
    hideOnFalsy: ['tipo_de_considerado'],
    defaultValue: false,
  },
  tipo_de_considerado: {
    formItemProps: {
      label: 'Tipo de Considerado',
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
